import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import {
  DocumentDetailsQuery,
  DocumentDetailsRecord,
  GenerateDocumentDetailsPdfPayload,
} from "./document-details.model";

@Injectable({
  providedIn: "root",
})
export class DocumentDetailsService {
  private url = environment.url;

  constructor(private http: HttpClient) {}

  /**
   * Funkcja odpowiedzialna za utworzenie lub aktualizację wersji dokumentu.
   * @since 10.07.2026
   */
  upsertDocumentDetails(payload: DocumentDetailsRecord) {
    return this.http.post<DocumentDetailsRecord>(
      `${this.url}/documents-details`,
      payload,
    );
  }

  /**
   * Funkcja odpowiedzialna za pobranie pojedynczej wersji dokumentu.
   * @since 10.07.2026
   */
  getSingleDocumentDetails(query: DocumentDetailsQuery) {
    return this.http.get<DocumentDetailsRecord>(
      `${this.url}/documents-details/single`,
      { params: { ...query } },
    );
  }

  /**
   * Funkcja odpowiedzialna za resetowanie szablonu dokumentu (czyszczenie renderedContent).
   * @since 10.07.2026
   */
  resetDocumentDetailsTemplate(query: DocumentDetailsQuery) {
    return this.http.patch<DocumentDetailsRecord>(
      `${this.url}/documents-details/reset-template`,
      {},
      { params: { ...query } },
    );
  }

  /**
   * Funkcja odpowiedzialna za pobranie PDF dokumentu
   * @since 18.08.2026
   */
  downloadPdfMake(orderId: string) {
    return this.http.get<Blob>(
      `${this.url}/documents-details/${orderId}/pdfmake`,
      {
        responseType: "blob" as "json",
      },
    );
  }
}
